import type { MoveScenario } from '@easymoving/types';

export interface DashboardLayout {
  /** How prominent the Settle-In CTA is. */
  settleInProminence: 'hero' | 'link' | 'light';
  /** Inventory section density: full grid vs slimmed. */
  inventoryDensity: 'full' | 'slim';
  /** Foreground the decide/declutter split (give-away/sell/donate/discard). */
  emphasizeDeclutter: boolean;
}

const LAYOUTS: Record<MoveScenario, DashboardLayout> = {
  home_to_home: { settleInProminence: 'link', inventoryDensity: 'full', emphasizeDeclutter: false },
  room_to_room: { settleInProminence: 'light', inventoryDensity: 'slim', emphasizeDeclutter: false },
  room_to_home: { settleInProminence: 'hero', inventoryDensity: 'slim', emphasizeDeclutter: false },
  home_to_room: { settleInProminence: 'light', inventoryDensity: 'full', emphasizeDeclutter: true },
};

/** Pure: the dashboard prominence flags for a scenario. */
export function dashboardLayout(scenario: MoveScenario): DashboardLayout {
  return LAYOUTS[scenario];
}
